import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {
  public data: any;  

  constructor(protected dialogRef: NbDialogRef<ConfirmationModalComponent>) {
    this.data = this.dialogRef;  
  }

  approve() {
    
    this.dialogRef.close({  isReview: false, isApproval:true,}); // Pass true to indicate approval
  }


  cancel() {
    this.dialogRef.close({  isReview: true, isApproval:false,}); // Pass false to indicate cancellation
  }
}

